import { Menu as BaseMenu } from '@base-ui/react/menu'

import { cn } from '@gto/ui/cn'

/**
 * 1px horizontal divider used between adjacent groups inside a menu popup.
 */
export const Separator = ({ className, ...props }: BaseMenu.Separator.Props) => {
  return (
    <BaseMenu.Separator
      className={cn('my-1 h-[1px] w-full shrink-0 bg-divider', className)}
      {...props}
    />
  )
}
